import { applyMiddleware, createStore, compose } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducers/rootReducer'
import { PUSH_ANALYTICS, TOGGLE_LOGIN_FORM } from './actions/stepActions'
import { createMiddleware as beaconReduxMiddlewareFactory } from 'redux-beacon'
import { GoogleTagManager as googleTagManagerFactory } from 'redux-beacon/targets/google-tag-manager'
import {
  getStepSlug,
  getProductCode,
  getActorSlug,
  getFloodLightGroup,
  getFloodLightActivity
} from '../utils'

// Define an event

const stepUpdate = (action, state) => ({
  hitType: 'dispatch',
  contactId: state.step.contactId || '',
  partnership: state.routing.partnership,
  floodLightGroup: getFloodLightGroup(state.step),
  floodLightActivity: getFloodLightActivity(state.step),
  floodLightQuantity: state.step.number === 6 ? '1' : '0',
  convention: state.routing.convention,
  actorSlug: getActorSlug(state.step),
  stepSlug: getStepSlug(state.step, state.product, state),
  productCode: getProductCode(state.step, state.product, state),
  stepError: state.step.hasServerErrors ? state.step.serverErrorMessage : '',
  isUnderage: !!state.step.isUnderage ? 'yes' : 'no',
  isParent: !!state.step.isParent ? 'yes' : 'no'
})

const loginFormUpdate = (action,state) => ({
  hitType: 'dispatch',
  actorSlug: getActorSlug(state.step),
  stepSlug: !!action.loginFormVisible ? 'auth' : ''
})

// Map the event to a Redux action
const eventsMap = {
  [PUSH_ANALYTICS]: stepUpdate,
  [TOGGLE_LOGIN_FORM]: loginFormUpdate
}

const middlewares = [
  thunk,
  beaconReduxMiddlewareFactory(eventsMap, googleTagManagerFactory())
]

if (process.env.NODE_ENV !== 'production') {
  const { createLogger } = require('redux-logger')
  const logger = createLogger({
    collapsed: true
  })
  middlewares.push(logger)
}

export default function configureStore(state) {
  const store = createStore(
    rootReducer,
    state,
    compose(applyMiddleware(...middlewares))
  )

  return store
}



// WEBPACK FOOTER //
// ./state/configureStore.js